import { useEffect, useState } from "react";
import AlertPopupModal from "./AlertPopupModal.jsx";
import {
  INACTIVE_USER_EVENT,
  clearSessionAndGoToLogin,
} from "../../utils/inactiveUserHandler.js";

export default function InactiveUserResponseHandler() {
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    const handleInactiveUser = (event) => {
      setPopupData({
        title: event?.detail?.title || "Information",
        message: event?.detail?.message || "",
      });
    };

    window.addEventListener(INACTIVE_USER_EVENT, handleInactiveUser);

    return () => {
      window.removeEventListener(INACTIVE_USER_EVENT, handleInactiveUser);
    };
  }, []);

  const handleClose = () => {
    setPopupData(null);
    clearSessionAndGoToLogin();
  };

  if (!popupData) return null;

  return (
    <AlertPopupModal
      title={popupData.title}
      message={popupData.message}
      onClose={handleClose}
      withBackdrop={true}
    />
  );
}
